var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

/* global FileReader */
var _require = require('readable-stream'),
    Readable = _require.Readable;

var toBuffer = require('typedarray-to-buffer');

var FileReadStream = /*#__PURE__*/function (_Readable) {
  "use strict";

  _inherits(FileReadStream, _Readable);

  function FileReadStream(file) {
    var _this;

    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, FileReadStream);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileReadStream).call(this, opts)); // save the read offset

    _this._offset = 0;
    _this._ready = false;
    _this._file = file;
    _this._size = file.size;
    _this._chunkSize = opts.chunkSize || Math.max(_this._size / 1000, 200 * 1024); // create the reader

    var reader = new FileReader();

    reader.onload = function () {
      // get the data chunk
      _this.push(toBuffer(reader.result));
    };

    reader.onerror = function () {
      _this.emit('error', reader.error);
    };

    _this.reader = reader; // generate the header blocks that we will send as part of the initial payload

    _this._generateHeaderBlocks(file, opts, function (err, blocks) {
      // if we encountered an error, emit it
      if (err) {
        return _this.emit('error', err);
      } // push the header blocks out to the stream


      if (Array.isArray(blocks)) {
        blocks.forEach(function (block) {
          return _this.push(block);
        });
      }

      _this._ready = true;

      _this.emit('_ready');
    });

    return _this;
  }

  _createClass(FileReadStream, [{
    key: "_generateHeaderBlocks",
    value: function _generateHeaderBlocks(file, opts, callback) {
      callback(null, []);
    }
  }, {
    key: "_read",
    value: function _read() {
      if (!this._ready) {
        this.once('_ready', this._read.bind(this));
        return;
      }

      var startOffset = this._offset;
      var endOffset = this._offset + this._chunkSize;
      if (endOffset > this._size) endOffset = this._size;

      if (startOffset === this._size) {
        this.destroy();
        this.push(null);
        return;
      }

      this.reader.readAsArrayBuffer(this._file.slice(startOffset, endOffset)); // update the stream offset

      this._offset = endOffset;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._file = null;

      if (this.reader) {
        this.reader.onload = null;
        this.reader.onerror = null;

        try {
          this.reader.abort();
        } catch (e) {}

        ;
      }

      this.reader = null;
    }
  }]);

  return FileReadStream;
}(Readable);

module.exports = FileReadStream;